export default "__VITE_ASSET__9d8e1d9a__"